import React from "react";
import cn from "classnames";
import styles from "./sources-list-header-for-gateways-list.module.scss";
import { useI18N } from "@src/language/language-context";

const cssClassName = "sources-list-header-for-gateways-list";

export const SourcesListHeaderForGatewaysList = () => {
  const i18n = useI18N();

  const texts = {
    statusAndMachineName: i18n(
      "modules.sourcesListHeaderForGatewaysList.statusAndMachineName",
    ),
    machineId: i18n("modules.sourcesListHeaderForGatewaysList.machineId"),
    dsnAddress: i18n("modules.sourcesListHeaderForGatewaysList.dsnAddress"),
    statusAndGatewayName: i18n(
      "modules.sourcesListHeaderForGatewaysList.statusAndGatewayName",
    ),
  };

  return (
    <thead>
      <tr className={styles[`${cssClassName}__header`]}>
        <td
          className={cn(
            styles[`${cssClassName}__grid-cell`],
            styles[`${cssClassName}__grid-cell-header`],
          )}
        >
          {texts.statusAndMachineName} {/* <QuestionMarkWithPopover /> */}
        </td>

        <td
          className={cn(
            styles[`${cssClassName}__grid-cell`],
            styles[`${cssClassName}__grid-cell-header`],
          )}
        >
          {texts.machineId}
        </td>
        <td
          className={cn(
            styles[`${cssClassName}__grid-cell`],
            styles[`${cssClassName}__grid-cell-header`],
          )}
        >
          {texts.dsnAddress}
        </td>
        {/* <td
          className={cn(
            styles[`${cssClassName}__grid-cell`],
            styles[`${cssClassName}__grid-cell-header`],
          )}
        >
          {texts.statusAndGatewayName}
        </td> */}
      </tr>
    </thead>
  );
};
